/* London & Co. — navigation behaviour (§8, §23, §26).
   Desktop mega panels, the search reveal, and the mobile push-level drawer.
   Plain DOM, no dependencies. Driven by data attributes so the script never
   needs to know the retail architecture — that lives in lc-nav-data.liquid. */
(function () {
  var header = document.querySelector('[data-lc-header]');
  if (!header || header.dataset.lcNavWired) return;
  header.dataset.lcNavWired = 'true';

  var drawer = document.getElementById('lc-drawer');
  var HOVER_IN = 90;
  var HOVER_OUT = 160;

  function panelFor(trigger) {
    var id = trigger.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function setExpanded(trigger, open) {
    var panel = panelFor(trigger);
    if (!panel) return;
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
    var item = trigger.closest('.lc-nav__item');
    if (item) item.setAttribute('data-open', open ? 'true' : 'false');
  }

  /* ------------------------------------------------- desktop mega panels */
  var triggers = Array.prototype.slice.call(header.querySelectorAll('[data-lc-mega-trigger]'));
  var hoverTimer = null;

  function closeAllMegas(except) {
    triggers.forEach(function (t) { if (t !== except) setExpanded(t, false); });
  }

  function finePointer() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  triggers.forEach(function (trigger) {
    var panel = panelFor(trigger);
    if (!panel) return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var open = trigger.getAttribute('aria-expanded') === 'true';
      closeAllMegas(trigger);
      setExpanded(trigger, !open);
    });

    /* Hover is a convenience on pointer devices; the click path above stays
       authoritative so keyboard and touch behave identically. */
    var zone = trigger.closest('.lc-nav__item');
    [zone, panel].forEach(function (el) {
      if (!el) return;
      el.addEventListener('mouseenter', function () {
        if (!finePointer()) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () {
          closeAllMegas(trigger);
          setExpanded(trigger, true);
        }, HOVER_IN);
      });
      el.addEventListener('mouseleave', function () {
        if (!finePointer()) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { setExpanded(trigger, false); }, HOVER_OUT);
      });
    });

    /* Tabbing out of the group closes it. */
    panel.addEventListener('focusout', function (e) {
      if (!panel.contains(e.relatedTarget) && e.relatedTarget !== trigger) setExpanded(trigger, false);
    });
  });

  document.addEventListener('click', function (e) {
    if (header.contains(e.target)) return;
    closeAllMegas(null);
  });

  /* ------------------------------------------------------- search reveal */
  var searchToggle = header.querySelector('[data-lc-search-toggle]');
  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      var open = searchToggle.getAttribute('aria-expanded') === 'true';
      closeAllMegas(null);
      setExpanded(searchToggle, !open);
      if (!open) {
        var panel = panelFor(searchToggle);
        var input = panel && panel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  /* --------------------------------------------------------- the drawer */
  if (!drawer) return;

  var lastFocus = null;
  var backBtn = drawer.querySelector('[data-lc-drawer-back]');
  var closeBtn = drawer.querySelector('[data-lc-drawer-close]');
  var titleEl = drawer.querySelector('[data-lc-drawer-title]');
  var level1 = drawer.querySelector('.lc-pane[data-level="1"]');

  function showLevel1() {
    Array.prototype.slice.call(drawer.querySelectorAll('.lc-pane')).forEach(function (p) {
      if (p.getAttribute('data-level') === '1') {
        p.setAttribute('data-shifted', 'false');
      } else {
        p.setAttribute('data-active', 'false');
      }
    });
    if (backBtn) backBtn.hidden = true;
    if (titleEl) titleEl.textContent = 'Menu';
  }

  function pushPane(name, label, source) {
    var pane = drawer.querySelector('[data-pane="' + name + '"]');
    if (!pane) return;
    if (level1) level1.setAttribute('data-shifted', 'true');
    pane.setAttribute('data-active', 'true');
    pane.scrollTop = 0;
    if (backBtn) { backBtn.hidden = false; backBtn.dataset.returnTo = source || ''; }
    if (titleEl) titleEl.textContent = label || 'Menu';
    var first = pane.querySelector('a, button');
    if (first) first.focus();
  }

  function openDrawer() {
    lastFocus = document.activeElement;
    drawer.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    showLevel1();
    if (level1) level1.scrollTop = 0;
    var ob = header.querySelector('[data-lc-drawer-open]');
    if (ob) ob.setAttribute('aria-expanded', 'true');
    var f = drawer.querySelector('input[type="search"], a, button');
    if (f) f.focus();
  }

  function closeDrawer() {
    drawer.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
    var ob = header.querySelector('[data-lc-drawer-open]');
    if (ob) ob.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  var openBtn = header.querySelector('[data-lc-drawer-open]');
  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backBtn) backBtn.addEventListener('click', function () {
    showLevel1();
    var ret = backBtn.dataset.returnTo;
    var src = ret && drawer.querySelector('[data-lc-push="' + ret + '"]');
    if (src) src.focus();
  });

  Array.prototype.slice.call(drawer.querySelectorAll('[data-lc-push]')).forEach(function (btn) {
    btn.addEventListener('click', function () {
      pushPane(btn.getAttribute('data-lc-push'), btn.getAttribute('data-lc-push-label'), btn.getAttribute('data-lc-push'));
    });
  });

  /* Keep tabbing inside the drawer while it owns the screen. */
  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = Array.prototype.slice.call(
      drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) { return el.offsetParent !== null && !el.hidden; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ------------------------------------------------------------- Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!drawer.hasAttribute('hidden')) {
      var active = drawer.querySelector('.lc-pane[data-active="true"]');
      if (active) { showLevel1(); } else { closeDrawer(); }
      return;
    }
    var openTrigger = triggers.filter(function (t) { return t.getAttribute('aria-expanded') === 'true'; })[0];
    if (openTrigger) { setExpanded(openTrigger, false); openTrigger.focus(); return; }
    if (searchToggle && searchToggle.getAttribute('aria-expanded') === 'true') {
      setExpanded(searchToggle, false); searchToggle.focus();
    }
  });
})();